import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this.dismissTimers = this.messageTargets.map((message) =>
      window.setTimeout(() => this.dismiss(message), this.timeoutValue)
    )
  }

  disconnect() {
    this.dismissTimers?.forEach((timer) => window.clearTimeout(timer))
  }

  dismiss(message) {
    if (!message?.isConnected) return

    message.style.opacity = "0"
    message.style.transform = "translateY(-8px)"

    window.setTimeout(() => {
      message.remove()

      if (this.messageTargets.length === 0) {
        this.element.remove()
      }
    }, 220)
  }
}
